const API = `${process.env.REACT_APP_BACKEND_URL}/api/leaderboards`;
const TOKEN_KEY = "ctlc-player";

// Anonymous random id for this device, used only to keep one entry per player in a group board.
export const playerToken = () => {
  let t = localStorage.getItem(TOKEN_KEY);
  if (!t) {
    t = crypto.randomUUID();
    localStorage.setItem(TOKEN_KEY, t);
  }
  return t;
};

export const readBoardCode = () => {
  const code = new URLSearchParams(window.location.search).get("classifica");
  return code && /^[\w-]{4,16}$/.test(code) ? code : null;
};

export const buildBoardUrl = (code) => `${window.location.origin}/?classifica=${code}`;

const request = async (url, body) => {
  const r = await fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : undefined);
  if (!r.ok) throw new Error(`Classifica: ${r.status}`);
  return r.json();
};

export const fetchBoard = (code) => request(`${API}/${code}?player=${encodeURIComponent(playerToken())}`);

export const createBoard = (ownerName) => request(API, { owner_name: ownerName });

export const submitEntry = (code, name, destinationIndex) =>
  request(`${API}/${code}/entries`, { player_token: playerToken(), name, destination_index: destinationIndex });
